import { createAction } from 'redux-actions'

const ns = 'activities/'

export const getUserActivities = createAction(`${ns}GET_USER_ACTIVITIES`)
export const getUserActivitiesSuccess = createAction(`${ns}GET_USER_ACTIVITIES_SUCCESS`)
export const getUserActivitiesFail = createAction(`${ns}GET_USER_ACTIVITIES_FAIL`)

// New actions for infinite scroll
export const loadMoreActivities = createAction(`${ns}LOAD_MORE_ACTIVITIES`)
export const loadMoreActivitiesSuccess = createAction(`${ns}LOAD_MORE_ACTIVITIES_SUCCESS`)
export const loadMoreActivitiesFail = createAction(`${ns}LOAD_MORE_ACTIVITIES_FAIL`)

// Lazy route loading: the list only carries a hasRoute flag; points load on first expand.
export const loadActivityRoute = createAction(`${ns}LOAD_ACTIVITY_ROUTE`) // payload { activityId }
export const loadActivityRouteSuccess = createAction(`${ns}LOAD_ACTIVITY_ROUTE_SUCCESS`) // { activityId, routes }
export const loadActivityRouteFail = createAction(`${ns}LOAD_ACTIVITY_ROUTE_FAIL`) // { activityId }

// Delete activity actions
export const deleteActivity = createAction(`${ns}DELETE_ACTIVITY`)
export const deleteActivitySuccess = createAction(`${ns}DELETE_ACTIVITY_SUCCESS`)
export const deleteActivityFail = createAction(`${ns}DELETE_ACTIVITY_FAIL`)

// Review duplicates modal actions
export const openReviewDuplicates = createAction(`${ns}OPEN_REVIEW_DUPLICATES`) // payload { activityId }
export const closeReviewDuplicates = createAction(`${ns}CLOSE_REVIEW_DUPLICATES`)
export const loadDuplicatesSuccess = createAction(`${ns}LOAD_DUPLICATES_SUCCESS`) // { activities, mainActivityId }
export const loadDuplicatesFail = createAction(`${ns}LOAD_DUPLICATES_FAIL`)

// Set main activity actions
export const setMainActivity = createAction(`${ns}SET_MAIN_ACTIVITY`) // payload { activityId }
export const setMainActivitySuccess = createAction(`${ns}SET_MAIN_ACTIVITY_SUCCESS`) // { activities, mainActivityId, previousMainId }
export const setMainActivityFail = createAction(`${ns}SET_MAIN_ACTIVITY_FAIL`)
